import { Box } from '@chakra-ui/react';

import { TextMedium, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';
import { Condition } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

const FieldDescription = ({ label, value, isLoading, skeletonWidth }) => {
  return (
    <Box className={styles['field-description__container']}>
      <TextRegular className={styles['label__text']}>{label}</TextRegular>
      <Condition statement={!isLoading} fallback={<SkeletonComponent height="14px" width={skeletonWidth} m=" 1px 0" />}>
        <TextMedium className={styles['value__text']}>{value || '-'}</TextMedium>
      </Condition>
    </Box>
  );
};

export default FieldDescription;
